import license from '../../Actions/license';
const { types } = license;

const initialState = {
    licenseStatus: {
        isValid: true,
    },
    licensePagination: {
        page: 1, 
        perPage: 10, 
        totalCount: 0, 
        items: [],
    },
    balance: [],
    invoiceData:null,
    isFreePlan: false,
    isOverflow:false
};

const licenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_LICENSE_DATA:
			return {
				...state,
                licenseStatus: action.data.licenseStatus,
            };
        case types.SET_LICENSES_HISTORICAL:
			return {
				...state,
                licensePagination: {
                    ...state.licensePagination,
                    items: action.data.licensePagination
                },
            };
        case types.SET_BALANCE_DATA:
            return {
                ...state,
                balance: action.data,
            };
            case types.SET_OVERFLOW:
                return {
                    ...state,
                    isOverflow: action.data,
                };
        case types.SET_INVOICE_DATA:
            return{
                ...state,
                invoiceData: action.data
            }
        case types.SET_INVOICE_FIELD:
            return {
                ...state,
                invoiceData: {
                    ...state.invoiceData,
                    ...action.data
                }
            }
        case types.SET_FREE_LICENSE_STATUS:
            return {
                ...state,
                isFreePlan: action.status
            }
        default:
            return state;
    }
}

export default licenseReducer;